var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlignmentVerticalCenterSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1568_1238)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 4.86189V0.999959C8 0.815864 8.14924 0.666626 8.33333 0.666626C8.51743 0.666626 8.66667 0.815864 8.66667 0.999959V4.86189L10.0976 3.43092C10.2278 3.30075 10.4389 3.30075 10.569 3.43092C10.6992 3.5611 10.6992 3.77215 10.569 3.90233L8.56904 5.90233C8.43886 6.0325 8.22781 6.0325 8.09763 5.90233L6.09763 3.90233C5.96746 3.77215 5.96746 3.5611 6.09763 3.43092C6.22781 3.30075 6.43886 3.30075 6.56904 3.43092L8 4.86189ZM8.66667 10.4714V14.3333C8.66667 14.5174 8.51743 14.6666 8.33333 14.6666C8.14924 14.6666 8 14.5174 8 14.3333V10.4714L6.56904 11.9023C6.43886 12.0325 6.22781 12.0325 6.09763 11.9023C5.96746 11.7722 5.96746 11.5611 6.09763 11.4309L8.09763 9.43092C8.22781 9.30075 8.43886 9.30075 8.56904 9.43092L10.569 11.4309C10.6992 11.5611 10.6992 11.7722 10.569 11.9023C10.4389 12.0325 10.2278 12.0325 10.0976 11.9023L8.66667 10.4714ZM2.33333 7.99996C2.14924 7.99996 2 7.85072 2 7.66663C2 7.48253 2.14924 7.33329 2.33333 7.33329H13.6667C13.8508 7.33329 14 7.48253 14 7.66663C14 7.85072 13.8508 7.99996 13.6667 7.99996H2.33333Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1568_1238"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16.6667,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignmentVerticalCenterSmall);
export default __webpack_public_path__ + "static/media/alignment-vertical-center-small.bdbe0b537aced2c9854f46e066d9475b.svg";
export { ForwardRef as ReactComponent };